<template>
	<modal ref="modal" size="modal-lg">
		<template #title>{{action.toUpperCase()}} INVESTOR ZOOM EVENT CONTENT</template>
		<template #body>

					<div class="form-floating mb-4">
						<input type="text" v-model="form.investor_zoom_topic" id="investor_zoom_topic" name="investor_zoom_topic" class="form-control" placeholder="Topic" />
						<label class="form-label" for="investor_zoom_topic">Topic</label>
					</div>
					<div class="form-floating mb-4">
						<div class="mb-4">
							<label class="form-label" for="investor_zoom_img">Event Image</label>
							<div class="fw-bold text-danger">Recommended Size: width:1150px height:648px</div>
							<input
								@change="onFileChange"
								type="file"
								id="investor_zoom_img"
								name="investor_zoom_img"
								class="form-control"
								:accept="[
					            'image/jpeg',
					            'image/jpg',
					            'image/png'
					          ]"
							/>
						</div>
						<div class="mb-4">
							<div v-if="form.prev_investor_zoom_img!=null"
								class="overflow-hidden rounded text-center bg-body-light border-start border-4 border-primary"
								style="height: 300px;background-size: contain;background-repeat: no-repeat;background-position: center;"
								:class="{'opacity-25':(form.investor_zoom_img!=form.prev_investor_zoom_img && form.prev_investor_zoom_img!=null && action=='update')}"
							>
								<img :src="form.investor_zoom_img_url" style="width:100%;" />
							</div>
							<div v-if="form.investor_zoom_img!=form.prev_investor_zoom_img && form.prev_investor_zoom_img!=null && action=='update'" class="text-center text-muted">
								<i class="fa fa-arrow-down fa-2x"></i>
							</div>
							<div>
								<div id="image-preview"
									class="overflow-hidden rounded text-center bg-body-light"
									style="background-size: contain;background-repeat: no-repeat;background-position: center;"
									:style="{'height':(form.investor_zoom_img!=form.prev_investor_zoom_img)?'300px':'0px'}"
								>
									
								</div>
								<div v-if="form.investor_zoom_img!=form.prev_investor_zoom_img && form.prev_investor_zoom_img!=null && action=='update'" class="text-center"><button @click="removeUploadImage" type="button" class="btn btn-outline-danger btn-sm"><i class="fa fa-times me-2"></i>Remove</button></div>
							</div>
						</div>
					</div>
					<div class="form-group mb-4">
						<label class="form-label" for="description">Description</label>
						<textarea id="ckeditor_announce"></textarea>
					</div>
					<div class="form-group mb-4">
						<label class="form-label" for="is_active">Status</label>
						<div class="mt-2">
							<div class="form-check form-check-inline">
								<input
									v-model="form.is_active"
									id="is_active_on"
									name="is_active"
									class="form-check-input"
									type="radio"
									value="1"
								/>
								<label class="form-check-label bg-alt-primary" for="is_active_on">ON</label>
							</div>
							<div class="form-check form-check-inline">
								<input
									v-model="form.is_active"
									id="is_active_off"
									name="is_active"
									class="form-check-input"
									type="radio"
									value="0"
								/>
								<label class="form-check-label bg-alt-primary" for="is_active_off">OFF</label>
							</div>
						</div>
					</div>
				
		</template>
		<template #footer>
			<button 
				@click="actionContent"
				type="submit"
				class="btn btn-alt-primary"
				:disabled="form.processing || !form.isDirty"
			>
				<span v-if="!form.processing"><i class="fa fa-save me-2"></i><span v-if="action=='add'">Add</span><span v-else>Update</span> Event</span>
					<span v-else>
						<div class="spinner-border spinner-border-sm text-dark" role="status" >
							<span class="sr-only mr-1">Please wait...</span>
						</div>
						<span class="mx-2">Please wait...</span>
					</span>
			</button>
			<button
				@click="toggleModal"
				type="button"
				class="btn btn-alt-secondary"
				:disabled="form.processing"
			>
				Close
			</button>
		</template>
	</modal>
</template>

<script>
import { watch, ref, reactive } from 'vue'
import { useForm } from '@inertiajs/inertia-vue3'
import { Inertia } from '@inertiajs/inertia'
import { createToaster } from '@meforma/vue-toaster';
import CKEditorInit from './../../Shared/ckeditor-init';

export default {
	props: {
		
	},
	mounted(){
		CKEditorInit('ckeditor_announce');
	},
	setup(props) {

		const toast = createToaster();

		const modal = ref(null)

		const toggleModal = () => {

			if(action.value=='add')
			{
				window['ckeditor_announce'].setData('<p></p>');
			}else
			{
				window['ckeditor_announce'].setData(form.investor_zoom_desc);
			}

			modal.value.toggleModal()
		}

		const editor 		= ref(null);
		const editorConfig 	= {};
		
		const action = ref('add');

		const form = useForm({
			investor_zoom_event_uuid: null,
			investor_zoom_topic		: null,
			investor_zoom_img 		: null,
			prev_investor_zoom_img 	: null,
			investor_zoom_img_url 	: null,
			investor_zoom_desc 		: '',
			is_active 				: 0,
		})

		const clearUpload = ()=>{
			$("#image-preview").html('');
			$("#investor_zoom_img").val('');
		}

		const onFileChange = (e) => {
			const image_preview = document.getElementById('image-preview')
			if (e.target.files.length > 0) {
				form.investor_zoom_img = e.target.files[0]
				const src = URL.createObjectURL(e.target.files[0])
				image_preview.innerHTML = `<img src="${src}" class="img-fluid" style="height:100%;width:auto" />`;
			} else {
				form.investor_zoom_img = null
				image_preview.innerHTML = ''
			}
		}

		const removeUploadImage = ()=>{
			form.investor_zoom_img = form.prev_investor_zoom_img;
			clearUpload();
		}

		const actionContent = ()=>{

			form.investor_zoom_desc = window['ckeditor_announce'].getData();

			if(action.value=='add')
			{
				addContent();
			}else
			{
				updateContent();	
			}
		}

		const addContent = () => {
			form.post(route('admin.post.investor-zoom-events'), {
				forceFormData: true,
				preserveState: true,
				preserveScroll: true,
				only:['events','api_response'],
				onSuccess: () => {
					form.reset();
					toggleModal();
				},
			})
		}

		const updateContent = () => {
			form.post('events/'+form.investor_zoom_event_uuid, {
				forceFormData: true,
				preserveState: true,
				preserveScroll: true,
				only:['events','api_response'],
				onSuccess: () => {
					form.reset();
					toggleModal();
				},
			})
		}

		const setInvestorZoomEventContent = (_action,data)=>{

								form.reset();

								if(_action=='update')
								{
									form.investor_zoom_event_uuid 	= data.investor_zoom_event_uuid;
									form.investor_zoom_topic 		= data.investor_zoom_topic;
									form.investor_zoom_img 			= data.investor_zoom_img;
									form.prev_investor_zoom_img 	= data.prev_investor_zoom_img;
									form.investor_zoom_img_url 		= data.investor_zoom_img_url;
									form.investor_zoom_desc 		= data.investor_zoom_desc;
									form.is_active 					= data.is_active;
								}
								
								action.value = _action;
							}


		return {
			toast,
			form,
			modal,
			toggleModal,
			editorConfig,
			clearUpload,
			onFileChange,
			removeUploadImage,
			action,
			setInvestorZoomEventContent,
			actionContent,
			addContent,
			updateContent,
		}
	},
}
</script>
<style>
	.ck-content,.ck-source-editing-area{
		height: 300px;
	}
</style>